// Edge-fade overflow cues for a horizontal scroller (#5154): toggles
// `has-overflow-left` / `has-overflow-right` on the element so the shell's
// `.gl-table-edge-cue` spans can signal clipped content on whichever side
// holds more. Every such scroller hides its scrollbar, so without the cues
// there is no affordance at all that more items exist.
//
// Shared by `settings_tabs_controller` (tab strips, which also center their
// active tab) and `overflow_cues_controller` (stat-card rows and any plain
// scroller). The React tree has its own twin, `useHorizontalOverflowCues` —
// keep the toggle semantics in lockstep across all three.
export function updateOverflowCues(el) {
  const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth)
  const hasHorizontalOverflow = maxScrollLeft > 1

  el.classList.toggle("has-overflow-left", hasHorizontalOverflow && el.scrollLeft > 1)
  el.classList.toggle("has-overflow-right", hasHorizontalOverflow && el.scrollLeft < maxScrollLeft - 1)
}

// Attaches the scroll listener + ResizeObserver and runs the first update.
// Returns a detach function for the caller's disconnect/cleanup.
export function attachOverflowCues(el) {
  const update = () => updateOverflowCues(el)
  update()

  el.addEventListener("scroll", update, { passive: true })
  const resizeObserver = new ResizeObserver(update)
  resizeObserver.observe(el)

  return () => {
    el.removeEventListener("scroll", update)
    resizeObserver.disconnect()
  }
}
